import { useEffect, useState } from "react";
import { fetchEmployeeDirectoryProfile } from "@/modules/hub/features/EmployeeDirectory/api/fetchEmployeeDirectoryProfile/fetchEmployeeDirectoryProfileApi";
import { Employee } from "@/modules/hub/features/EmployeeDirectory/api/fetchEmployeeDirectoryProfiles/types";

export interface UseProfileDetailsPageReturn {
  loading: boolean;
  member: Employee | null;
}

export const useProfileDetailsPage = (
  uuid: string | undefined,
): UseProfileDetailsPageReturn => {
  const [member, setMember] = useState<Employee | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!uuid) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setMember(null);

    fetchEmployeeDirectoryProfile(uuid)
      .then((response) => {
        if (cancelled) return;
        setMember(response.data);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [uuid]);

  return { loading, member };
};
